import * as request from '../../request'
import * as serializers from './serializers'

// Reset Password

export const resetPasswordSentEmail = async (data) => {
  try {
    const res = await request.post('v1/users/reset-password', data)

    return serializers.resetPasswordSentEmail(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const preResetPassword = async (id, token, data) => {
  try {
    const res = await request.patch(`v1/users/${id}/pre-reset-password`, data, {
      params: {
        confirmToken: token
      }
    })

    return serializers.resetPasswordSentEmail(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const resetPassword = async (id, slt, data) => {
  try {
    const res = await request.patch(`v1/users/${id}/reset-password`, data, {
      headers: {
        'x-slt': slt
      }
    })

    return serializers.resetPassword(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

// Register User

export const registerUser = async (data) => {
  try {
    const res = await request.post('v1/users', data)

    return serializers.registerUser(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const confirmUserPhone = async (id, slt, data) => {
  try {
    const res = await request.patch(
      `v1/users/${id}/confirm-phone-number`,
      data,
      {
        headers: {
          'x-slt': slt
        }
      }
    )

    return serializers.confirmUserPhone(res)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const confirmUserEmail = async (id, token) => {
  try {
    const res = await request.patch(
      `v1/users/${id}/confirm-email?confirm_token=${token}`
    )

    return serializers.confirmUserEmail(res)
  } catch (err) {
    return Promise.reject(err)
  }
}
